const $ = jQuery;

const ShowMoreGallery = {
  slider: $(".gallery-images-slider"),
  init: () => {
    ShowMoreGallery.slider.slick({
      infinite: true,
      centerMode: true,
      slidesToShow: 1,
      autoplay: false,
      dots: false,
      prevArrow: $(".gallery-images-slider-bottom .gallery-images-slider-prev"),
      nextArrow: $(".gallery-images-slider-bottom .gallery-images-slider-next"),
      adaptiveHeight: true,
      focusOnSelect: true
    });
    ShowMoreGallery.slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
     
      var i = (currentSlide ? currentSlide : 0) + 1;
      $(".gallery-images-slider-counter .current-count").text(i)
    });
    $('[data-slidecount]').click(function(e){
      $("body").addClass("active-gallery-popup")
      var slideno = $(this).data('slidecount');
      ShowMoreGallery.slider.slick('slickGoTo', slideno - 1, true);
    });
    $(".gallery-close").on("click", function(){
      $("body").removeClass("active-gallery-popup")
    })
    // Pronađi wrapper galerije
    const galleryWrapper = document.querySelector(".gallery-images");
    if (!galleryWrapper) return;

    // Pronađi sve slike i dugme
    const galleryItems = document.querySelectorAll(".gallery-item");
    const showMoreButton = document.querySelector(".show-more-btn");
    const showTextMore = showMoreButton.querySelector(".show-text.more");
    const showTextLess = showMoreButton.querySelector(".show-text.less");

    // Prikaži samo prvih 4 slika
    galleryItems.forEach((item, index) => {
      if (index <= 5) {
        item.classList.add("active");
      }
    });

    let currentVisibleIndex = 6;

    // Dodaj event listener na dugme
    showMoreButton.addEventListener("click", (e) => {
      e.preventDefault();

      if (showTextMore.style.display !== "none") {
        // Prikaži sve slike
        let newLimit = galleryItems.length - 1;
        galleryItems.forEach((item, index) => {
          if (index <= newLimit) {
            item.classList.add("active");
          }
        });

        currentVisibleIndex = newLimit;

        if (currentVisibleIndex >= galleryItems.length - 1) {
          showTextMore.style.display = "none";
          showTextLess.style.display = "inline";
        }
      } else {
        // Sakrij dodatne slike
        galleryItems.forEach((item, index) => {
          if (index > 5) {
            item.classList.remove("active");
          }
        });

        currentVisibleIndex = 5;
        showTextMore.style.display = "inline";
        showTextLess.style.display = "none";
      }
    });
  },
};

export default ShowMoreGallery;
